<template>
  <div>
    <v-row>
      <v-col cols="6">
        <template v-if="selectedApplication && applicationLocal">
          <v-form
            ref="form"
            v-model="valid"
            :lazy-validation="true"
          >
            <v-text-field
              v-model="applicationLocal.organizationalNumber"
              v-mask="mask"
              outlined
              :loading="isLoading"
              placeholder="nnnnnn-nnnn"
              data-cy="company-number"
              :rules="[rules.orgnr]"
              @input="changeOrg"
            ></v-text-field>
          </v-form>
        </template>
      </v-col>
      <v-col cols="6">
        <v-expand-transition v-if="newCompany && companyShow">
          <v-card>
            <v-card-title data-cy="company-name-title">
              <h6>{{ newCompany.name }}</h6>
            </v-card-title>
            <v-card-subtitle class="mt-n6">{{ newCompany.postalAddress1 }} ,{{ newCompany.organizationalNumber }}</v-card-subtitle>
          </v-card>
        </v-expand-transition>
        <v-expand-transition v-if="showMsg">
          <v-card
            outlined
            flat
          >
            <v-card-text class="subtitle-2">Det här företaget finns inte i våra system.</v-card-text>
          </v-card>
        </v-expand-transition>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import API from '@/services/api.js'
import get from 'lodash/get'
import {mapActions, mapGetters} from 'vuex'
import {mask} from 'vue-the-mask'
import {RulesMixin, InstructorAbilities, Utilities} from '@/components/mixins'

export default {
  name: 'ApplicationCompanyEdit',

  props: {
    application: {
      type: Object,
      required: true
    },

    initApplicationCompanyState: {
      type: Object,
      required: true
    }
  },

  mixins: [RulesMixin, InstructorAbilities, Utilities],

  directives: {
    mask
  },

  data: () => ({
    newCompany: {},
    showMsg: false,
    companyShow: false,
    isLoading: false,
    valid: false,
    mask: '######-####'
  }),

  created() {
    if (this.$refs.form && this.$refs.form !== undefined) {
      this.$refs.form.resetValidation()
    }
  },

  computed: {
    ...mapGetters('application', [
      'selectedApplication',
      'applicationCompany',
      'applicationWorkplace',
      'applicationDepartments'
    ]),

    applicationLocal: {
      get() {
        return this.application
      },

      set(value) {
        this.$emit('change-application', value)
      }
    },

    initApplicationCompanyStateLocal: {
      get() {
        return this.application
      },

      set(value) {
        this.$emit('change-company-state', value)
      }
    }
  },

  methods: {
    ...mapActions('application', ['updateSelectedApplication']),

    // @vuese
    // Used to get the company
    // @arg The argument is Org number of the company
    getCompany() {
      let orgNo = get(this, 'applicationLocal.organizationalNumber', null)

      if (orgNo) {
        orgNo = orgNo.split('-').join('')
      }

      if (orgNo.length < 9) {
        this.newCompany = {}
        this.showMsg = false
        return
      }

      API.listCompanies({
        startAt: 0,
        sortBy: false,
        sortDesc: false,
        pageSize: 1000000,
        organizationalNumber: String(this.applicationLocal.organizationalNumber)
      })
        .then(res => {
          if (res.data.count == 0) {
            this.showMsg = true
            this.companyShow = false
          } else {
            this.newCompany = res.data.rows[0]
            this.showMsg = false
            this.companyShow = true
            orgNo = res.data.rows[0].id
            this.getCompanyById()
          }
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => (this.isLoading = false))
    },

    // @vuese
    // Used to get the company
    // @arg The argument is id of the company
    getCompanyById() {
      console.log('Get company by id', this.applicationLocal.companyId)
      if (this.applicationLocal && this.applicationLocal.id && this.applicationLocal.companyId) {
        API.getCompany(this.applicationLocal.companyId)
          .then(async res => {
            if (res.data) {
              this.company = res.data
              this.$set(this.applicationLocal, 'organizationalNumber', res.data.organizationalNumber)
              this.initApplicationCompanyStateLocal.organizationalNumber = res.data.organizationalNumber
            }
            this.firstLoad = false
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        this.firstLoad = false
      }
    },

    // @vuese
    // Used to update the applcation to the db and to the store if the application exist otherwise create a new one
    saveChangeCompany() {
      if (this.selectedApplication && this.selectedApplication.id) {
        if (
          (!this.applicationLocal && this.applicationLocal.organizationalNumber == null) ||
          this.applicationLocal.organizationalNumber.length < 9
        ) {
          this.applicationLocal.companyId = null
          this.applicationLocal.instructorId = null
          this.applicationLocal.workplaceId = null
          this.applicationLocal.departmentId = null
          this.company = {}
          this.newCompany = {}
        }
        //-Update Application

        API.updateApplication(this.selectedApplication.id, {
          data: this.applicationLocal
        })
          .then(response => {
            if (response.data) {
              this.$events.fire('showInfo', 'Anmälan sparad.')
              this.$emit('saved')
            }
          })
          .catch(error => {
            console.log('There was an error:', error.response)
          })
      } else {
        this.$events.fire('showError', 'Ingen anmälan angiven, testa att ladda om sidan.')
      }
    },

    changeOrg() {
      if (this.applicationLocal && this.applicationLocal.organizationalNumber) {
        this.applicationLocal.organizationalNumber = this.applicationLocal.organizationalNumber.split('-').join('')
      }

      if (
        this.applicationLocal &&
        this.applicationLocal.organizationalNumber &&
        this.applicationLocal.organizationalNumber.length === 10
      ) {
        this.getCompany()
      } else {
        this.companyShow = false
        this.applicationLocal.instructorId = null
        this.applicationLocal.workplaceId = null
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>"